import { type Editor } from '@meitu/saas-editor-core';
import {
    LayerType,
    type EditingRange,
    type ITextContent,
    type ITextLayerProps,
} from '@meitu/saas-editor-core/es/version-types';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';

export const useTextContent = (editor: Editor, range: EditingRange | null) => {
    const textContents = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer || layer.layerType !== LayerType.TEXT_LAYER) return [];

        const layerData = layer.data as ITextLayerProps;
        const { textContents = [] } = layerData;

        return textContents;
    }) as ITextContent[];

    const textContent = (() => {
        if (!range || textContents.length === 0) return null;

        const { startIndex } = range;
        return textContents[startIndex];
    })();

    return textContent;
};
